import { Box } from '@mui/material';
import { observer } from 'mobx-react';
import { useMasterData } from '@ui-framework/providers/AppDataProvider';
import ChatbotWidget from './ChatbotWidget';
import {
  ChatbotProvider,
  useChatbotPanel,
  SIDE_PANEL_WIDTH,
} from './ChatbotContext';

function ChatbotPageMargin({ children }) {
  const { isSidePanelOpen } = useChatbotPanel();
  return (
    <Box
      sx={{
        marginRight: isSidePanelOpen ? `${SIDE_PANEL_WIDTH}px` : 0,
        transition: 'margin-right 0.3s ease',
        minHeight: '100vh',
      }}>
      {children}
    </Box>
  );
}

function WithChatbotLayoutInner({ WrappedComponent, ...props }) {
  const masterData = useMasterData();
  const chatbotEnabled = masterData?.chatbotEnabled === true;

  if (!chatbotEnabled) {
    return <WrappedComponent {...props} />;
  }
  return (
    <ChatbotProvider>
      <ChatbotWidget />
      <ChatbotPageMargin>
        <WrappedComponent {...props} />
      </ChatbotPageMargin>
    </ChatbotProvider>
  );
}

const WithChatbotLayoutInnerObserved = observer(WithChatbotLayoutInner);

function withChatbotLayout(WrappedComponent) {
  function WithChatbotLayout(props) {
    return (
      <WithChatbotLayoutInnerObserved
        WrappedComponent={WrappedComponent}
        {...props}
      />
    );
  }
  WithChatbotLayout.displayName = `WithChatbotLayout(${
    WrappedComponent?.displayName ?? WrappedComponent?.name ?? 'Component'
  })`;
  return WithChatbotLayout;
}

export default withChatbotLayout;
